import { injectedStore } from '../../ConfigureStore';

export default function getDeviceUUID(): string {
  return injectedStore.getState().device.deviceUUID;
}
